// removed by extract-text-webpack-plugin
module.exports = {"publicsection":"wmf-p1kWe-et","publlictitle":"wmf-2uqlAJLJ","required":"wmf-Jb9x8R-a","informationtitle":"wmf-28DefBI_","titles":"wmf-2E8Hsktz"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/commoditymanagement/commoditydetails/basiccommoditydetails/basic-commodity-details.module.less
// module id = 617
// module chunks = 0